import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";
import { identifyUser, logoutAnalytics, setUserProps } from "../analytics/posthog";
import { reconcileConsent } from "../lib/consentSync";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Returning from Google OAuth: let AuthCallback exchange the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  // Identify in analytics with the stable internal id (no-op until consent).
  useEffect(() => {
    if (user && user.user_id) {
      identifyUser(user.user_id);
      setUserProps({ workspace_id: user.workspace_id, plan: user.plan });
      reconcileConsent(user);
    }
  }, [user]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    logoutAnalytics();
    setUser(false);
    window.location.href = "/";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, refresh: checkAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
